import { AnalyticsStore } from 'bernie-plugin-mobx';
import { History, Location } from 'history';
import { trackAnalyticsList, trackAnalytics } from 'utility';
import { FlightsStoresType } from 'utility/hooks';
import { AnalyticsType } from '../types/shared/analytics';

export const applySelectSheet = (
  identifier: string,
  itemIndex: number,
  stores: FlightsStoresType,
  history: History,
  location: Location,
  pwaDialog?: string,
  upsellOfferToken?: string
) => {
  const {
    dynamicElementsStore,
    analytics: analyticsStore,
    detailsAndFaresStore,
    flightsSelectedJourneyReviewStore,
    priceSummaryStore
  } = stores;

  const dynamicElementsGroupTrackEventAnalytics = dynamicElementsStore.getDynamicElementsGroupTrackEventAnalytics(
    identifier
  );
  if (dynamicElementsGroupTrackEventAnalytics) {
    const { analyticsList, stringifiedAllFlightProducts } = dynamicElementsGroupTrackEventAnalytics;
    const { linkName, referrerId } = analyticsList[0];

    analyticsStore.trackEvent(referrerId, linkName, analyticsStore.omnitureData, null, true, [
      {
        schemaName: 'allFlightProducts',
        messageContent: JSON.parse(stringifiedAllFlightProducts)
      }
    ]);
  }
  detailsAndFaresStore.cleanSelectedState();
  flightsSelectedJourneyReviewStore.updateInformation(
    itemIndex,
    identifier,
    dynamicElementsStore,
    priceSummaryStore,
    history,
    location,
    pwaDialog,
    upsellOfferToken
  );
  trackAnalyticsList(flightsSelectedJourneyReviewStore.onFareSelectAnalytics, analyticsStore);
  flightsSelectedJourneyReviewStore.cleanSelectedAnalytics();
  detailsAndFaresStore.cleanInitialSelectedFareIndex();
};

export const faresLoadingAnalyticsRender = (
  faresLoadingDisplayedAnalytics: AnalyticsType,
  faresLoadingTimeAnalytics: AnalyticsType,
  analytics
) => {
  trackAnalytics(faresLoadingDisplayedAnalytics, analytics);
  if (typeof performance?.getEntriesByName === 'function') {
    const componentRenderDuration = (
      window.performance.getEntriesByName('FareLoaderRender')[0]?.duration / 1000
    )?.toFixed(0);
    faresLoadingTimeAnalytics.referrerId = faresLoadingTimeAnalytics.referrerId.replace(
      '${X}',
      componentRenderDuration
    );
    trackAnalytics(faresLoadingTimeAnalytics, analytics);
  }
};

export const sendUisTrackEvent = (analyticsList, analyticsStore: AnalyticsStore) => {
  analyticsList.forEach(analytics => {
    const { linkName, referrerId, uisPrimeMessages } = analytics;
    uisPrimeMessages.length > 0 &&
      uisPrimeMessages.map(uisPrimeMessage =>
        analyticsStore.trackEvent(referrerId, linkName, analyticsStore.omnitureData, null, true, [
          {
            schemaName: uisPrimeMessage.schemaName,
            messageContent: JSON.parse(uisPrimeMessage.messageContent)
          }
        ])
      );
  });
};
